import * as d3 from 'd3'
import Defs from '../../../../includes/primitives/colorDefs'
import Data from '../../../../includes/primitives/Color_Data'

export default {
  methods: {

    draw_TubeChart(d_, p_) {
      let cht = this.chart
      let tube = this.tube
      let base = this.base

      let TubeChart = this.canvasForms
      .append('g')
      .attr('transform', `translate(${p_.x}, ${p_.y})`)
      .style('font-family', 'roboto')

      this.set_ColorDefs(TubeChart)

      cht.scale = d3.scaleLinear()
      .domain([0, 100])
      .rangeRound([tube.height, 0])

      Defs.setDefs_Reflections(TubeChart, this.localId)
      Defs.setDefs_Gradients(TubeChart, 0, 'LinearA2', tube.color, [1, 0.5, .5, 0.5], this.localId)
      Defs.setDefs_Gradients(TubeChart, 1, 'LinearA9', tube.color, [0, 0.5, 1, 0.5], this.localId)


      // Start from here
      TubeChart
      .append('g')
      .attr('transform', `translate(${cht.x + (tube.tickness/2)},${cht.y + (tube.tickness/4)})`)


      // ---------------------------  Reflected Effect
      TubeChart // Reflected Box
      .append('rect')
      .attr('transform', `translate(0, ${tube.height + base.height})`)
      .attr('width', tube.tickness).attr('height', base.height).attr('opacity', '0.75')
      .attr('fill', '#E0E0DF').attr('opacity', .5)

      TubeChart // Transparent Gradation Area
      .append('rect')
      .attr('transform', `translate(${-tube.tickness / 2},${tube.height + base.height})`)
      .attr('width', tube.tickness * 2.5).attr('height', base.height + 2)
      .attr('fill', `url(#${this.localId}__Color_Reflection)`)

      TubeChart // Shadow
      .append('ellipse')
      .attr('cx', tube.tickness / 4).attr('cy', tube.height + base.height)
      .attr('rx', (tube.tickness * 1.5) / 2).attr('ry', (tube.tickness * 1.5) / 3 / 2)
      .attr('fill', `url(#${this.localId}_Shadow)`)


      // --------------------------- d.base.height Cylinder
      TubeChart // Bottom Box
      .append('rect')
      .attr('transform', `translate(0,${tube.height})`)
      .attr('width', tube.tickness).attr('height', base.height)
      .attr('fill', `url(#${this.localId}_TubeBase)`)

      TubeChart // Bottom Cap Bottom
      .append('ellipse')
      .attr('cx', tube.tickness / 2) .attr('cy', tube.height + base.height)
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2)
      .attr('fill', `url(#${this.localId}_TubeBase)`)


      //  --------------------------- Tube Cylinder
      TubeChart
      .append('rect') // Tube Cylinder Box
      .attr('width', tube.tickness).attr('height', tube.height).attr('fill', `url(#${this.localId}_TubeBox)`).attr('opacity', 1)

      TubeChart // Bottom Cap
      .append('ellipse')
      .attr('cx', tube.tickness / 2).attr('cy', tube.height)
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', '#E0E0DF').attr('opacity', 0.9)

      TubeChart // Top Cap
      .append('ellipse')
      .attr('cx', tube.tickness / 2).attr('cy', 0)
      .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_TubeCap)`)


      // --------------------------- Color Cylinder
      let ra = (this.tube.tickness/2)
      let rh = this.tube.tickness/3/2
      let height =  cht.scale(0) - cht.scale(d_.A_CUM)

      TubeChart
      .append('path')
      .attr('d', 
        `M${0} ${cht.scale(0)} A${ra} ${rh} 0 0 0 ${this.tube.tickness} ${cht.scale(0)}` 
      )
      .attr('fill', `none`).attr('stroke', '#fff').attr('opacity', 0.5)
      .transition()
      .duration(500)
      .attr('d', 
        `M${0} ${cht.scale(0)-height} A${ra} ${rh} 0 0 0 ${this.tube.tickness} ${cht.scale(0)-height}` 
      )
      
      if (d_.A_CUM > 0) {
        TubeChart
        .append('path')
        .attr('d', 
          `M${0} ${cht.scale(0)} A${ra} ${rh} 0 0 0 ${this.tube.tickness} ${cht.scale(0)} V${cht.scale(0)}
          A${ra} ${rh} 0 0 1 ${0} ${cht.scale(0)} V${cht.scale(0)}` 
        )
        .attr('fill', `url(#${this.localId}_${tube.color}_1)`)
        .attr('opacity', tube.opacity ? tube.opacity : .9)
        .transition()
        .duration(500)
        .attr('d', 
          `M${0} ${cht.scale(0)} A${ra} ${rh} 0 0 0 ${this.tube.tickness} ${cht.scale(0)} V${cht.scale(0)-height}
          A${ra} ${rh} 0 0 1 ${0} ${cht.scale(0)-height} V${cht.scale(0)}` 
        )

        TubeChart // Bottom Cap
        .append('ellipse')
        .attr('cx', tube.tickness / 2).attr('cy', tube.height)
        .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_1)`).attr('opacity', tube.opacity ? tube.opacity : .9)
  
        TubeChart // Top Cap
        .append('ellipse')
        .attr('cx', tube.tickness / 2).attr('cy', cht.scale(0))
        .attr('rx', tube.tickness / 2).attr('ry', tube.tickness / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_0)`).attr('opacity', tube.opacity ? tube.opacity : .9)
        .transition().duration(500).attr('cy', cht.scale(d_.A_CUM))
      }

      this.draw_Values(TubeChart, d_)

      // --------------------------- Details
      this.draw_Detail(TubeChart, d_)
    },

    draw_Detail(selection, d_) {
      let cht = this.chart
      let tube = this.tube
      let base = this.base
      let props = this.multiProps

      let details = selection
      .append('g')
      .attr('transform', `translate(${0}, ${tube.height + base.height + props.yPos})`)

      if (props && props.name) {
        details
        .append('text')
        .attr('x', tube.tickness/2).attr('y', props.nameSize * 0.36)
        .attr('font-size', props.nameSize)
        .attr('fill', '#333')
        .attr('text-anchor', 'middle')
        .text(d_[props.name])
      }

      props.summary.forEach((d, i) => {
        details
        .append('text')
        .attr('x', -10).attr('y', 30 + 18 * i)
        .attr('font-size', 11)
        .attr('fill', '#333')
        .text(d.name)

        details
        .append('text')
        .attr('x', 65).attr('y', 30 + 18 * i)
        .attr('font-size', 11)
        .attr('fill', '#333')
        .attr('text-anchor', 'end')
        .text(`${d_[d.code]}%`)

        if (d_[d.delta] && d_[d.delta] != 0) {
          let delta = details
          .append('text')
          .attr('x', 70).attr('y', 30 + 18 * i)
          .attr('font-size', 11)
          .attr('fill', this.gmx_deltaValue(d_[d.delta]))
          .text(`${d_[d.delta]}%`)

          details
          .append('path')
          .attr('transform', `translate(${70 + delta.node().getBBox().width + 2}, ${30 + 18 * i - 9}) scale(${0.7})`)
          .attr('d', this.gmx_deltaValue(d_[d.delta], 'icon'))
          .attr('fill', this.gmx_deltaValue(d_[d.delta]))
        }
      })
    },
  }
}